import { render } from "./ShareComponent.vue?vue&type=template&id=fcd57136&ts=true"
import script from "./ShareComponent.vue?vue&type=script&lang=ts"
export * from "./ShareComponent.vue?vue&type=script&lang=ts"

import "./ShareComponent.vue?vue&type=style&index=0&id=fcd57136&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__